import {
  AutomationActionType,
  CreateAutomationTaskInput,
  RequirementConditionType
} from 'services/automation/types';
import { AutomationFormItem, FormValues } from '../types';

export const validateAutomationItem = (item: AutomationFormItem) => {
  const { requirementConditions, action } = item;
  const { conversationStatus, type } = requirementConditions[0];

  if (!requirementConditions.some((condition) => condition.type)) {
    return false;
  }

  if (
    type === RequirementConditionType.CONVERSATION_STATUS_CONDITION &&
    !conversationStatus
  ) {
    return false;
  }

  if (
    action.type === AutomationActionType.SEND_DOCUMENT_VIA_EMAIL &&
    !action.recipientEmailAddress
  ) {
    return false;
  }

  if (
    action.type === AutomationActionType.UPDATE_ATS &&
    !action.atsInterviewStageId &&
    !action.atsRejectedReasonId
  ) {
    return false;
  }

  return true;
};

export const validateAutomationItems = (values: FormValues) =>
  values.every((item) => validateAutomationItem(item));

export const getValidAutomationItems = (values: FormValues) =>
  values.filter((item) =>
    validateAutomationItem(item)
  ) as CreateAutomationTaskInput[];
